var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNopPhatNguoiCircleBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8991_28659)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#EE0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21C8.36111 21 7.86806 20.8299 7.52083 20.4896C7.17361 20.1493 7 19.6528 7 19V16H9V5L10.2 6.20833L11.4 5L12.6 6.20833L13.8 5L15 6.20833L16.2 5L17.4 6.20833L18.6 5L19.8 6.20833L21 5V18.75C21 19.4028 20.7847 19.941 20.3542 20.3646C19.9236 20.7882 19.3889 21 18.75 21H9ZM18.75 19.5C18.9722 19.5 19.1528 19.434 19.2917 19.3021C19.4306 19.1701 19.5 18.9861 19.5 18.75V7.5H10.5V16H18V18.75C18 18.9861 18.0694 19.1701 18.2083 19.3021C18.3472 19.434 18.5278 19.5 18.75 19.5ZM11.5 10.5V9H16V10.5H11.5ZM11.5 13V11.5H16V13H11.5ZM17.75 10.5C17.5556 10.5 17.3819 10.4285 17.2292 10.2856C17.0764 10.1427 17 9.96563 17 9.75438C17 9.54313 17.0764 9.36458 17.2292 9.21875C17.3819 9.07292 17.559 9 17.7604 9C17.9618 9 18.1354 9.07146 18.2812 9.21437C18.4271 9.35729 18.5 9.53437 18.5 9.74562C18.5 9.95687 18.4281 10.1354 18.2844 10.2812C18.1406 10.4271 17.9625 10.5 17.75 10.5ZM17.75 13C17.5556 13 17.3819 12.9285 17.2292 12.7856C17.0764 12.6427 17 12.4656 17 12.2544C17 12.0431 17.0764 11.8646 17.2292 11.7188C17.3819 11.5729 17.559 11.5 17.7604 11.5C17.9618 11.5 18.1354 11.5715 18.2812 11.7144C18.4271 11.8573 18.5 12.0344 18.5 12.2456C18.5 12.4569 18.4281 12.6354 18.2844 12.7812C18.1406 12.9271 17.9625 13 17.75 13ZM9 19.5H16.5V17.5H8.5V19C8.5 19.2361 8.52431 19.3785 8.57292 19.4271C8.62153 19.4757 8.76389 19.5 9 19.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8991_28659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNopPhatNguoiCircleBrand);
export default __webpack_public_path__ + "static/media/nopPhatNguoi_circle_brand.d74a610b06fc99a1ba73bd13ade5c5a0.svg";
export { ForwardRef as ReactComponent };